export const ListQueryKey = 'products';
export const DetailQueryKey = 'product';
export const Urls = {
  selectUrl: '/commodity/item/list',
  updateUrl: '/commodity/item/update',
  deleteUrl: '/commodity/item/delete',
  createUrl: '/commodity/item/create',
  detailUrl: '/commodity/item/detail'
};